module.exports = __webpack_public_path__ + "img/Delete-icon.0ac075fa.svg";